









































































import CtrlAddBtn from '@/components/common/control/CtrlAddBtn.vue';
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import G_020_JuchuEntry_ChildHeaderInput from '@/components/G_kaigai/G_020_JuchuEntry_ChildHeaderInput.vue';
import G_020_JuchuEntry_Table from '@/components/G_kaigai/G_020_JuchuEntry_Table.vue';
import { OutStatus, ShoriKb } from '@/constants/constants';
import { dateNumToStr, dateStrToNum } from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_020_JuchuEntry',
  components: {
    CtrlMessageDialog,
    CtrlResetBtn,
    CtrlClearBtn,
    CtrlAddBtn,
    CtrlDatePicker,
    G_020_JuchuEntry_ChildHeaderInput,
    G_020_JuchuEntry_Table,
  },
  data: () => ({
    hatchuYmdF: '',
    hatchuYmdT: '',
    search: '',
    items: [],
    ShoriKb,
    shoriKb: ShoriKb.ADD,
    childHeaderInputItem: {},
    childHeaderInputShow: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  methods: {
    initValues() {
      this.hatchuYmdF =
        this.userInfo &&
        this.userInfo.onlineData &&
        moment(this.userInfo.onlineData.genzaiYmd.toString())
          .subtract(1, 'month')
          .format()
          .substr(0, 10);
      this.hatchuYmdT = moment(this.userInfo.onlineData.genzaiYmd.toString())
        .format()
        .substr(0, 10);
      this.search = '';
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.items = [];
        this.getData();
      }
    },
    handlClear() {
      this.initValues();
      this.items = [];
    },
    handleOkMessage() {
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;

      if (this.isClearTable) {
        this.isClearTable = false;
        this.items = [];
      }
    },
    handleAdd() {
      this.childHeaderInputItem = {
        juchuEntryJigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        juchuEntryYmd: this.userInfo.onlineData.genzaiYmd,
      };
      this.shoriKb = ShoriKb.ADD;
      this.childHeaderInputShow = true;
    },
    handleInfo(item: any) {
      this.childHeaderInputItem = item;
      this.shoriKb = ShoriKb.REFER;
      this.childHeaderInputShow = true;
    },
    handleEdit(item: any) {
      this.childHeaderInputItem = item;
      this.shoriKb = ShoriKb.UPD;
      this.childHeaderInputShow = true;
    },
    handleChildHeaderInputHide(reload: boolean) {
      if (reload) {
        this.getData();
      }
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (!dateStrToNum(this.hatchuYmdF) || !dateStrToNum(this.hatchuYmdT)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['発注日'];
        this.messageShow = true;
        return;
      }
      if (
        this.hatchuYmdF &&
        this.hatchuYmdT &&
        dateStrToNum(this.hatchuYmdF) > dateStrToNum(this.hatchuYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['発注日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        hatchuYmdF: dateStrToNum(this.hatchuYmdF),
        hatchuYmdT: dateStrToNum(this.hatchuYmdT),
      };
      const res = await this.$store.dispatch('g020/getJuchuEntry', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isClearTable = true;
        return;
      }

      this.items = res.data.responseData
        ? res.data.responseData.map((item: any) => ({
            ...item,
            juchuEntryYmd: dateNumToStr(item.juchuEntryYmd),
          }))
        : [];
    },
  },
  created() {
    if (
      !this.userInfo.riyoshaTokuisakiData ||
      !this.userInfo.riyoshaTokuisakiData.length
    ) {
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者マスタの得意先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.initValues();
  },
});
